import React from 'react';
import { Link } from 'react-router-dom';
import { Megaphone, ArrowRight, Globe2 } from 'lucide-react';

// Top leaderboard advertising banner. Clicking routes to the Contact page.
export default function TopBanner() {
  return (
    <Link to="/contact" className="block group" aria-label="Advertise with TMB Global News">
      <div
        className="w-full text-white"
        style={{ background: 'linear-gradient(90deg, #0b3d26 0%, #0f5132 45%, #157347 100%)' }}
      >
        <div className="max-w-[1320px] mx-auto px-4 py-2.5 flex items-center justify-center gap-3 text-center">
          <Megaphone className="w-5 h-5 shrink-0 text-[#8be0b0] hidden sm:block" />
          <p className="text-[13px] sm:text-sm font-medium tracking-wide">
            <span className="font-semibold">Advertise to over 5 million people</span>
            <span className="hidden sm:inline"> locally &amp; globally</span>
            <span className="mx-2 text-[#8be0b0]">—</span>
            <span className="text-[#cdeddb]">Place your ad here</span>
          </p>
          <span className="inline-flex items-center gap-1 text-[12px] sm:text-[13px] font-semibold bg-white/12 group-hover:bg-white/22 transition-colors rounded-full px-3 py-1 border border-white/20">
            <Globe2 className="w-3.5 h-3.5" />
            Advertise
            <ArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5" />
          </span>
        </div>
      </div>
    </Link>
  );
}
